<div style="width: 100%" class="d-flex flex-column align-items-center justify-content-between">
  <app-admin-header style="width: 100%" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [queryParams]="queryParams" [stats]="stats"></app-admin-header>

  <div class="w-100">
    <!-- skelition   -->
    <app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
  </div>
  <div class="container-fluid mb-5 px-5 pt-5 3333" *ngIf="!skelition">
    <div class="container">
      <h2 class="v4-color-white">{{ trainingDetails.title }}</h2>
      <h6 class="v4-color-white">
        {{ trainingDetails.start_date | date }} -
        {{ trainingDetails.end_date | date }}
      </h6>
      <div class="row">
        <div *ngFor="let item of trainingDetailsData" class="col-3 my-2">
          <div class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4">
            <span class="{{ item.icon }} " style="width: 4rem; height: 4rem"></span>
            <hr class="hr w-75 border-4" />
            <h5 class="text-center p-2">{{ item.arabic | translator }}</h5>
            <h1>{{ item.value }}</h1>
          </div>
        </div>
      </div>
      <hr class="hr w-75 border-4 v4-color-white" />
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-0 p-0">
          <p-tabView class="v4-bg-white ui-tabview v4-dsbrd-btns" [activeIndex]="activeTRTabIndex"
            (onChange)="onTabChange($event)">
            <p-tabPanel class="v4-bg-white ui-tabview v4-dsbrd-btns" header="{{ 'Survey' | translator }}">
              <app-no-data *ngIf="surveys.length <= 0"></app-no-data>
              <div class="row v4-graph-bg" *ngFor="let survey of surveys">
                <div class="container">
                  <div>
                    <h2 class="v4-color-white">
                      {{ survey.title }}
                    </h2>
                    <h6 class="v4-color-white">{{ survey.start_time | date }} - {{ survey.end_time | date}}</h6>
                  </div>
                  <p-button (click)="openUrl('survey',survey.surveyId)" [label]="'View Details' | translator"
                    icon="pi pi-eye"></p-button>
                </div>
                <app-no-data *ngIf="survey.graphData.length <= 0"></app-no-data>
                <ng-container *ngFor="let data of survey.graphData">
                  <div class="col-md-4" style="padding: 2%" *ngIf="!noGraphs.includes(data.questionType)">
                    <div *ngIf="data.type">
                      <h6 class="text-center v4-color-white">
                        {{ data.questionText | translator }}
                      </h6>
                      <div *ngIf="data.type == 'text'">
                        <p-table [columns]="data.data.labels" [value]="data.data.datasets[0].data"
                          [tableStyle]="{ 'min-width': '50rem' }">
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              <th *ngFor="let col of columns">
                                {{ col }}
                              </th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                              <td *ngFor="let col of columns; let i = index">
                                {{ rowData[i] !== "" ? rowData[i] : "-" }}
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                      <div *ngIf="data.type == 'bar'">
                        <p-chart type="bar" [data]="data.graphData" [options]="barChartOptions" height="400"></p-chart>
                      </div>
                      <div *ngIf="data.type == 'calander'">
                        <table class="w-100">
                          <thead>
                            <tr>
                              <th> * </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of data.meta">
                              <td>{{ formatDate(row.value) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div *ngIf="data.type == 'smile'">
                        <div class="row">
                          <div class="col-md-12 col-12 my-2">
                            <div class="d-flex flex-row">
                              <div class="rating-bg" *ngFor="let data of data.graphData">
                                <div class="rating-item">
                                  <img class="rating-width" src="{{ data.image }}" alt="loading" />
                                  <div class="rating-label v4-color-white">
                                    {{ data.label | translator }} ({{ data.count }})
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="data.type == 'rate'">
                        <div class="row w-100">
                          <div class="row w-100" *ngFor="let data of data.graphData">
                            <div class="col-md-12 col-12 my-2">
                              <div class="label-container">
                                <div class="rating-container">
                                  <p-rating class="v4-ratting" [disabled]="true" [(ngModel)]="data.value"
                                    [cancel]="false"></p-rating>
                                </div>
                                <strong class="v4-color-white">{{ data.label | translator }}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr class="hr" />
                    </div>
                  </div>
                </ng-container>
              </div>
            </p-tabPanel>
            <p-tabPanel header="{{ 'Assessment' | translator }}">
              <p-table *ngIf="users.length > 0" [value]="users" dataKey="_id" [tableStyle]="{ 'min-width': '50rem' }">
                <ng-template pTemplate="header">
                  <tr>
                    <th [width]="30">{{ 'the name' | translator }}</th>
                    <th [width]="30">{{ 'Email' | translator }}</th>
                    <th [width]="20" class="text-center" *ngFor="let assessment of assessments">
                      <div [pTooltip]="assessment.title">
                        {{assessment.title.substring(0,10)}} {{ assessment.title.length > 10 ? "..." : null}}
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                  <tr>
                    <td>
                      {{ getName(user.name) }}
                    </td>
                    <td>
                      {{ user.email }}
                    </td>
                    <td *ngFor="let assessment of user.assessments" class="text-center">
                      <ng-container *ngIf="assessment.result.length > 0">
                        <div style="margin-bottom: 15px;">
                          <strong>
                            {{ assessment?.result[0]?.criteria }}
                          </strong>
                          |
                          % {{ assessment?.result[0]?.percentage }}
                        </div>
                        <p-button [pTooltip]="'View Details' | translator"
                          (click)="openUrl('assessment',assessment.assessmentId)" icon="pi pi-eye"></p-button>
                      </ng-container>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-tabPanel>
            <p-tabPanel header="{{ 'Rating' | translator }}">
              <div class="row">
                <div class="col-3 my-2">
                  <div
                    class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4">
                    <span class="icon-svg icon-svg-85" style="width: 4rem; height: 4rem"></span>
                    <hr class="hr w-75 border-4" />
                    <h5 class="text-center p-2">{{ 'avgTrainerRating' | translator}}</h5>
                    <h1>
                      <p-rating [(ngModel)]="ratingDetails.avgTrainerRating" [readonly]="true"
                        [cancel]="false"></p-rating>
                    </h1>
                  </div>
                </div>
                <div class="col-3 my-2">
                  <div
                    class="card assess-card h-100 d-flex flex-column justify-content-between align-items-center px-2 py-4">
                    <span class="icon-svg icon-svg-3" style="width: 4rem; height: 4rem"></span>
                    <hr class="hr w-75 border-4" />
                    <h5 class="text-center p-2">{{ 'avgUserRating' | translator}}</h5>
                    <h1>
                      <p-rating [(ngModel)]="ratingDetails.avgUserRating" [readonly]="true" [cancel]="false"></p-rating>
                    </h1>
                  </div>
                </div>
              </div>
              <div class="active-panel">
                <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="CurrTab === 'Users'"
                  (click)="ChangeTab('Users', $event)">
                  {{ "User Rating" | translator }}
                </h5>
                <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="CurrTab === 'Trainers'"
                  (click)="ChangeTab('Trainers', $event)">
                  {{ "Trainers Rating" | translator }}
                </h5>
              </div>
              <app-no-data *ngIf="CurrTab === 'Users' && ratingDetails.user_ratings.length <= 0"></app-no-data>
              <p-table *ngIf="CurrTab === 'Users' && ratingDetails.user_ratings.length > 0"
                [value]="ratingDetails.user_ratings" [tableStyle]="{'min-width': '50rem'}" [paginator]="true"
                [rows]="5">
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{'Email' | translator}}</th>
                    <th>{{'Rating' | translator}}</th>
                    <th>{{'Action' | translator}}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-users>
                  <tr>
                    <td>{{users?.email}}</td>
                    <td>
                      <p-rating [(ngModel)]="users.avg" [readonly]="true" [cancel]="false">
                      </p-rating>
                    </td>
                    <td>
                      <p-button (click)="openUrl('survey',users.surveyIds,'Trainer',users.userId)"
                        [label]="'View Details' | translator" icon="pi pi-eye"></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <app-no-data *ngIf="CurrTab === 'Trainers' && ratingDetails.trainer_ratings.length <= 0"></app-no-data>
              <p-table *ngIf="CurrTab === 'Trainers' && ratingDetails.trainer_ratings.length > 0"
                [value]="ratingDetails.trainer_ratings" [tableStyle]="{'min-width': '50rem'}" [paginator]="true"
                [rows]="5">
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{'Email' | translator}}</th>
                    <th>{{'Rating' | translator}}</th>
                    <th>{{'Action' | translator}}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-trainers>
                  <tr>
                    <td>{{trainers?.email}}</td>
                    <td>
                      <p-rating [(ngModel)]="trainers.avg" [readonly]="true" [cancel]="false">
                      </p-rating>
                    </td>
                    <td>
                      <p-button (click)="openUrl('survey',trainers.surveyIds,'User',trainers.userId)"
                        [label]="'View Details' | translator" icon="pi pi-eye"></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>